module.exports = __webpack_public_path__ + "static/the-venue-of-hollywood-brochure-2f564183410124d576c3fd92c515c0ca.pdf";